module.exports = __webpack_public_path__ + "static/media/LogoAppMosph2N.c16bd783.png";